import { EventDto } from 'api/dtos/event';

export const getEventOccurrenceDate = (event: Pick<EventDto, 'originalOccurrenceDate' | 'originalDateFrom' | 'dateFrom'>) =>
    event.originalOccurrenceDate ?? event.originalDateFrom ?? event.dateFrom;

export const getEventOccurrenceKey = (event: Pick<EventDto, 'id' | 'entityEventId' | 'originalOccurrenceDate' | 'originalDateFrom' | 'dateFrom' | 'dateTo'>) => [
    event.id,
    event.originalOccurrenceDate ?? event.originalDateFrom ?? event.dateFrom,
    event.entityEventId ?? '',
    event.dateFrom,
    event.dateTo,
].join('__');
